export function resolveAssetPath(url: string) {
  if (!url || /^(?:https?:|blob:|data:)/i.test(url)) return url;
  const base = import.meta.env.BASE_URL || "/";
  return `${base.replace(/\/$/, "")}/${url.replace(/^\//, "")}`;
}
